import { enableProdMode, StaticProvider } from '@angular/core'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import {
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptorConfiguration
} from '@azure/msal-angular'
import { LogLevel, PublicClientApplication } from '@azure/msal-browser'

if (environment.production) {
  enableProdMode()
}

const isIEBrowser =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1

/**
 * msal logger
 * @param logLevel log level
 * @param message message log
 */
function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log("MSAL Angular: ", message);
}

/**
 * provider setting
 * @param param0 provider setting param
 * @returns provider
 */
function msalStaticProvider({ msal, guard, interceptor }): StaticProvider[] {
  return [
    {
      provide: MSAL_INSTANCE,
      useValue: new PublicClientApplication({
        auth: msal.auth,
        cache: {
          ...msal.cache,
          storeAuthStateInCookie: isIEBrowser
        },
        system: {
          /**
           * Rút thời gian chờ iframe silent từ mặc định 6000ms xuống 3000ms.
           *
           * Khi refresh token hết hạn (AADSTS700084 - SPA refresh token có vòng đời cố
           * định 24h), MSAL không ném lỗi ra ngoài mà tự chuyển sang hidden iframe. Trên
           * Chrome/Edge chặn 3rd-party cookie thì iframe này CHẮC CHẮN timeout, không
           * phải may rủi. Interceptor còn thử lại một lần nữa, nên với mặc định 6000ms
           * người dùng phải nhìn spinner ~12 giây trước khi thấy popup.
           *
           * Chỉ đặt iframeHashTimeout, KHÔNG đặt loadFrameTimeout: loadFrameTimeout là
           * giá trị mặc định cho CẢ windowHashTimeout (popup, mặc định 60000ms), đặt nó
           * sẽ vô tình rút luôn thời gian chờ popup xuống 3 giây.
           *
           * Chọn 3000ms chứ không thấp hơn để chừa biên cho mạng chậm: iframe silent
           * thành công thường mất dưới 1 giây, nhưng qua proxy công ty có thể lâu hơn.
           * Đặt quá thấp sẽ làm người dùng mạng chậm bị bắt đăng nhập lại một cách oan uổng.
           */
          iframeHashTimeout: 3000,
          loggerOptions: {
            loggerCallback,
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false
          }
        }
      })
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: guard.interactionType,
        authRequest: guard.authRequest,
        loginFailedRoute: guard.loginFailedRoute
      } as MsalGuardConfiguration
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: interceptor.interactionType,
        protectedResourceMap: new Map(interceptor.protectedResourceMap)
      } as MsalInterceptorConfiguration
    }
  ]
}
function fetchConfig() {
  // Fetch i18n
  Promise.all([
    fetch('/assets/i18n/en.json').then((res) => {
      return res.json()
    }),
    fetch('/assets/i18n/vi.json').then((res) => {
      return res.json()
    })
  ])
    .then(([langEn, langVi]) => {
      if (langVi && langEn) {
        // SetLang
        window['en'] = langVi
        window['vi'] = langEn
        // Fetch Config SSO
        fetch('/assets/env/sso.config.json')
          .then((res) => {
            return res.json()
          })
          .then((data) => {
            // Set Config
            window['sso'] = data?.sso
            window['isLoginNormal'] = data?.isLoginNormal
            // Load app
            platformBrowserDynamic(msalStaticProvider(data))
              .bootstrapModule(AppModule)
              .catch((err) => console.error(err))
          })
          .catch((err) => console.log(err))
      }
    })
    .catch((err) => console.log(err))
}

fetchConfig()
